import { useState, useEffect } from "react"
import axios from "axios"
import * as yup from "yup"
import schema from "../validation/formSchemaManager"

import "../../styles/ManagerRegister.css"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

const initialSignUpForm = {
  role: 2,
  email: "",
  display_name: "",
  phone: "",
  password: "",
  password_confirm: "",
  sec_question: "",
  sec_answer: ""
}

const initialFormErrors = {
  role: "",
  email: "",
  display_name: "",
  phone: "",
  password: "",
  password_confirm: "",
  sec_question: "",
  sec_answer: ""
}

function ManagerAddForm() {
  const [ signUpForm, setSignUpForm ] = useState(initialSignUpForm)
  const [ formErrors, setFormErrors ] = useState(initialFormErrors)
  const [ disabled, setDisabled ] = useState(true)

  const handleSignUpChange = e => {
    const {name, value} = e.target
    yup
      .reach(schema, name)
      .validate(value)
      .then(() => {
        setFormErrors({
          ...formErrors,
          [name]: ""
        })
      })
      .catch(err => {
        setFormErrors({
          ...formErrors,
          [name]: err.errors[0]
        })
      })

    setSignUpForm({
      ...signUpForm,
      [e.target.name]: e.target.value
    })
  }

  const handleSignUpSubmit = e => {
    e.preventDefault()
    let newUser = {
      role: signUpForm.role,
      email: signUpForm.email.toLowerCase(),
      display_name: signUpForm.display_name,
      phone: signUpForm.phone,
      password: signUpForm.password,
      sec_question: signUpForm.sec_question,
      sec_answer: signUpForm.sec_answer
    }


    axios.post("https://roma-be.herokuapp.com/api/auth/register", newUser)
      .then(res => {
        setSignUpForm(initialSignUpForm)
        toast(`Welcome to the team ${res.data.user.display_name}!`)
      })
      .catch(() => {
        toast(`Something went wrong`)
      })
  }

  useEffect(() => {
    schema.isValid(signUpForm).then(valid => {
      setDisabled(!valid)
    })
  }, [signUpForm])

  return (
    <div className="msu-container">      
      <form onSubmit={handleSignUpSubmit} className="msu-form">
        {signUpForm.role ?
          <span className="su-errors">{formErrors.role}</span>
        : null}
        <select name="role" type="dropdown" className="msu-input" onChange={handleSignUpChange}>
          <option value={2}>Manager</option>
          <option value={3}>Administrator</option>
        </select>

        {signUpForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input
          className="msu-input"
          type="text" 
          name="email" 
          placeholder="Email" 
          onChange={handleSignUpChange} 
          value={signUpForm.email}
        />

        {signUpForm.display_name ?
          <span className="su-errors">{formErrors.display_name}</span>
        : null}
        <input 
          className="msu-input"
          type="text" 
          name="display_name" 
          placeholder="Display Name" 
          onChange={handleSignUpChange} 
          value={signUpForm.display_name} 
        />

        {signUpForm.phone ?
          <span className="su-errors">{formErrors.phone}</span>
        : null}
        <input 
          className="msu-input"
          type="phone" 
          name="phone" 
          placeholder="Phone # (optional)" 
          onChange={handleSignUpChange} 
          value={signUpForm.phone} 
        />

        {signUpForm.password ?
          <span className="su-errors">{formErrors.password}</span>
        : null}
        <input 
          className="msu-input"
          type="password" 
          name="password" 
          placeholder="Password" 
          onChange={handleSignUpChange} 
          value={signUpForm.password} 
        />
        
        {signUpForm.password_confirm ?
          <span className="su-errors">{formErrors.password_confirm}</span>
        : null}
        {signUpForm.password_confirm ?
          signUpForm.password_confirm !== signUpForm.password ?
            <span className="su-errors">*Passwords must match</span>
          : null
        : null}
        <input 
          className="msu-input"
          type="password" 
          name="password_confirm" 
          placeholder="Confirm Password" 
          onChange={handleSignUpChange} 
          value={signUpForm.password_confirm} 
        />

        {signUpForm.sec_question ?
          <span className="su-errors">{formErrors.sec_question}</span>
        : null}
        <select name="sec_question" type="dropdown" className="msu-input" onChange={handleSignUpChange}>
          <option value="">Select a Secuirty Question</option>
          <option value="What is your mother's maiden name?">What is your mother's maiden name?</option>
          <option value="What was your first pet's name?">What was your first pet's name?</option>
          <option value="What was the address of your childhood home?">What was the address of your childhood home?</option>
          <option value="What was the name of your elemetary school?">What was the name of your elemetary school?</option>
          <option value="What was your first grade teacher's name?">What was your first grade teacher's name?</option>
        </select>

        {signUpForm.sec_answer ?
          <span className="su-errors">{formErrors.sec_answer}</span>
        : null}
        <input 
          className="msu-input"
          type="password" 
          name="sec_answer" 
          placeholder="Security Question Answer" 
          onChange={handleSignUpChange} 
          value={signUpForm.sec_answer}
        />

        <div className="msu-submit-container">
          {signUpForm.password_confirm ?
            signUpForm.password_confirm === signUpForm.password ?
              <button disabled={disabled} className="ad-tool">Submit</button>
            : <button disabled={true} className="ad-tool">Submit</button>
          : <button disabled={true} className="ad-tool">Submit</button>}
        </div>        
      </form>
    </div>
  )
}

export default ManagerAddForm
